<div class="wrapper">
  <div class="container">
    @if (data.title) {
      <div class="title" tnTestId="full-screen-title" tnTestIdType="text">{{ data.title }}</div>
    }
    @if (data.message) {
      <p class="message" tnTestId="full-screen-message" tnTestIdType="text" [class.pre]="data.pre">{{ data.message }}</p>
    }
  </div>
  @if (data.showClose) {
    <tn-button
      color="primary"
      testId="close-full-screen"
      [label]="'Continue' | translate"
      (onClick)="close()"
    ></tn-button>
  }
</div>
